import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.12 } } };
const item = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16,1,0.3,1] } } };

export function Stats() {
  const { t, dict } = useI18n();
  const stats = dict.stats.items;

  return (
    <section id="cifras" className="relative py-20 lg:py-32" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-emerald-500" />
              <p className="eyebrow">{t("stats.eyebrow")}</p>
            </div>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05]">
              {t("stats.heading")}
            </h2>
          </div>
        </div>

        <motion.div
          className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-slate-800 border border-slate-800 rounded-3xl overflow-hidden"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          {stats.map((s, i) => (
            <motion.div key={i} variants={item} className="p-8 lg:p-10" data-testid={`stat-item-${i + 1}`}>
              <p className="font-display text-4xl lg:text-6xl font-bold tracking-tight">
                {s.value}
              </p>
              <p className="mt-3 text-xs font-mono uppercase tracking-widest text-slate-400 leading-relaxed">
                {s.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Stats;
